import adminDeclar from '../../images/docs/admin-declar.png';
import NomImport from '../../images/docs/nomenclator-import.png';

export const meta = {
  slug: 'incarca-intrastat',
  title: 'Încarcă Intrastat',
  description: 'Cum încărcați fișierul Intrastat generat în platforma oficială INS.',
  icon: 'upload',
  order: 9,
  related: ['machete', 'generare-intrastat'],
};

export const images = { adminDeclar, NomImport };

export const content = `
# Încarcă Intrastat

După generarea fișierului XML al declarației Intrastat prin platforma ProgramIntrastat.ro, urmați pașii de mai jos pentru a-l importa, valida și transmite prin aplicația oficială offline pusă la dispoziție de Institutul Național de Statistică (INS).

### Descărcarea aplicației oficiale și a nomenclatorului actualizat
   Accesați site-ul oficial INS dedicat Intrastat:  
   http://www.intrastat.ro/di2.php  
   Descărcați:  
   - ultima versiune a aplicației offline Intrastat, și  
   - cel mai recent fișier XML cu nomenclatorul NC8 (codurile de 8 cifre).

### Actualizarea nomenclatorului NC8 în aplicația INS
   Deschideți aplicația oficială INS.  
   Mergeți la meniul:  
   **Acțiuni → Nomenclatoare → Import...**  
   Selectați fișierul XML cu nomenclatorul NC8 descărcat anterior și efectuați importul.  
   Așteptați confirmarea importului cu succes.

   ::image[NomImport]{alt="Schimbare temă (importa nomencaltor)"}


### Importul declarației generate de ProgramIntrastat.ro
   În aplicația INS, accesați:  
   **Acțiuni → Administrare Declarații → Import...**  
   Selectați fișierul XML generat de platforma ProgramIntrastat.ro.  
   După încărcare, declarația va apărea în lista declarațiilor.

   ::image[adminDeclar]{alt="Schimbare temă (administrare declarații intrastat)"}

### Validare și salvare / transmitere
   Selectați declarația importată și efectuați validarea (butonul de verificare erori).  
   După validarea cu succes, salvați declarația și pregătiți-o pentru transmitere către INS (conform instrucțiunilor oficiale).

**Notă:** Recomandăm să utilizați întotdeauna cea mai recentă versiune a aplicației și a nomenclatorului NC8 publicate pe site-ul oficial intrastat.ro pentru a evita erorile de compatibilitate sau de validare.
`;
